import React from 'react';

const numericColumns = new Set([
  'salary',
  'auction_value',
  'contract_length',
  'salary_relief',
  'contract_relief',
  'cap_penalty',
]);

export const sortPlayers = (players = [], sort) => {
  const direction = sort.direction === 'asc' ? 1 : -1;

  return [...players].sort((a, b) => {
    if (sort.key === 'player_name') {
      const nameA = a.name || a.player_name || '';
      const nameB = b.name || b.player_name || '';
      return String(nameA).localeCompare(String(nameB)) * direction;
    }

    if (numericColumns.has(sort.key)) {
      const valueA = a[sort.key] == null ? null : Number(a[sort.key]);
      const valueB = b[sort.key] == null ? null : Number(b[sort.key]);
      const validA = Number.isFinite(valueA);
      const validB = Number.isFinite(valueB);

      if (!validA) return validB ? 1 : 0;
      if (!validB) return -1;
      return (valueA - valueB) * direction;
    }

    return 0;
  });
};

const SortableHeader = ({ label, column, sort, onSort, className }) => {
  const indicator = sort.key === column
    ? ` ${String.fromCharCode(sort.direction === 'asc' ? 9650 : 9660)}`
    : '';

  return (
    <th className={className}>
      <button type="button" className="sortable-th" onClick={() => onSort(column)}>
        {label}{indicator}
      </button>
    </th>
  );
};

export default SortableHeader;
